import { render, staticRenderFns } from "./FinishRoltekRequestButton.vue?vue&type=template&id=5e0ddf04&scoped=true"
import script from "./FinishRoltekRequestButton.vue?vue&type=script&lang=ts"
export * from "./FinishRoltekRequestButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ddf04",
  null
  
)

export default component.exports